import { render } from "./createActions.vue?vue&type=template&id=fef602a0"
import script from "./createActions.vue?vue&type=script&lang=js"
export * from "./createActions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__